import { Constants } from '../constants/constants';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import Swal from 'sweetalert2/dist/sweetalert2.all.js'; //CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { Utils } from '../utils/utils';

@Injectable({
  providedIn: 'root'
})
export class EncuestaService {
  constructor(private http: HttpClient, private utils:Utils) {}

  public getEncuestas(): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_ENCUESTA;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError(err => {
        console.log(JSON.stringify(err));
        if (err.status === 401) {
          this.utils.cerrarSesion();
        } else {
          Swal.fire({
            title: 'Error Encuesta',
            text: 'Error Cargando Encuestas.',
            type: 'error'
          });
        }  
        
        return throwError(err);
      })
    );
  }

  public getEncuestaCopiar(idEncuesta): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_ENCUESTA + '/' + idEncuesta;
    return this.http.get<any>(url /*, {headers:httpHeaders}*/).pipe(
      catchError(err => {
        console.log(JSON.stringify(err));
        Swal.fire({
          title: 'Error Encuesta',
          text: 'Error Cargando Encuestas.',
          type: 'error'
        });
        return throwError(err);
      })
    );
  }

  public putReordenaEncuestaBloque(encuestaBloque): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_ENCUESTA_BLOQUE + '/1';
    return this.http.put<any>(url, encuestaBloque).pipe(
      catchError(err => {
        Swal.fire({
          title: 'Error Bloque Encuesta',
          text: 'Error Reordenando bloque encuesta.',
          type: 'error'
        });
        return throwError(err);
      })
    );
  }

  public putEncuestaBloque(encuestaBloque): Observable<any> {
    const url = Constants.BASE_URL + Constants.URL_ENCUESTA_BLOQUE;
    return this.http.put<any>(url, encuestaBloque).pipe(
      catchError(err => {
        Swal.fire({
          title: 'Error Bloque Encuesta',
          text: 'Error agregando bloque encuesta.',
          type: 'error'
        });
        return throwError(err);
      })
    );
  }

  public deleteEncuestaBloque(encuestaBloque): Observable<any> {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      body: encuestaBloque
    };

    const url = Constants.BASE_URL + Constants.URL_ENCUESTA_BLOQUE;
    return this.http.delete<any>(url, options).pipe(
      catchError(err => {
        Swal.fire({
          title: 'Error Bloque Encuesta',
          text: 'Error eliminando bloque encuesta.',
          type: 'error'
        });
        return throwError(err);
      })
    );
  }
}
